import Challenge from "./challenge";
import Match from "./match";
import NotFound from "./notFound";
import Searching from "./searching";

import { useState, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { initializePeerAndAttachHandlers, connectToPeerAndAttachHandlers, peerEventHandlers, connEventHandlers, sendMessage, setConnnectionHandler, attachDataConnectionHandlers, attachPeerHandlers, disconnectPeer, logBrokerConnectionStatus, destroyPeer, resetConnHandlers, resetPeerHandlers } from "../p2p";

import { fetchIdFromUrlPath, displayPopMessage, getOpposite } from "../utils";

import UTTT from "../logic/uttt";
import TTT from "../logic/ttt";

import startSoundFile from './audio/start.mp3';
import moveSoundFile from './audio/move.mp3';
import endSoundFile from './audio/end.mp3';

let startAudio = new Audio(startSoundFile);
let moveAudio = new Audio(moveSoundFile);
let endAudio = new Audio(endSoundFile);

let match;

function Game(props) {

  // let match;

  const location = useLocation();
  const navigate = useNavigate();

  const [matchHasStarted, setMatchHasStarted] = useState(false);
  const [matchFinished, setMatchFinished] = useState(false);
  const [notFound, setNotFound] = useState(false);
  // above is what to show state

  // below is match related state
  // const [iAm, setIAm] = useState(null); // 'X', 'O' , 'Spectating' ... only matters if match is ongoing
  const [representations, setRepresentations] = useState(null);
  const [bigRepresentations, setBigRepresentations] = useState(null);
  const [lastMove, setLastMove] = useState(null);
  const [allAllowed, setAllAllowed] = useState(null);
  const [nextTurn, setNextTurn] = useState(null);
  const [topMessage, setTopMessage] = useState(null);

  // update/set the frequently changing match state objects
  function updateMatchState(match) {
    // console.log(match);
    setLastMove(match.getLastMove());
    setRepresentations(match.getRepresentations());
    setBigRepresentations(match.getBigRepresentations());
    setAllAllowed(match.isAllAllowed());
    setNextTurn(match.getNextTurn());
  }

  function endMatchBasedOnResult(mResult) {
    let reason;
    if (mResult == 'X') {
      if (location.state && location.state.iCreatedChallenge) {
        reason = 'Yayy!! You won!';
      } else {
        reason = 'You lost :(';
      }
    }
    if (mResult == 'O') {
      if (location.state && location.state.iCreatedChallenge) {
        reason = 'You lost :(';
      } else {
        reason = 'Yayy!! You won!';
      }
    }
    if (mResult == 'draw') {
      reason = 'No one won, its a draw :/';
    }
    setMatchFinished(true);
    setTopMessage(reason);
    setNextTurn(null);
    setAllAllowed(null);
    setLastMove(null);
    endAudio.play();
  }

  useEffect(() => {

    // setInterval(() => {
    //   logBrokerConnectionStatus();
    // }, 1000);

    if (!matchHasStarted) {

      connEventHandlers.error = (err) => {
        console.log(`conn error = ${err.type}`);
        console.log(`conn error = ${err.message}`);
        displayPopMessage(`connError: ${err.type}`);
        displayPopMessage(`connError: ${err.message}`);
      };

      if (location.state && location.state.iCreatedChallenge) {
        // console.log(`peer ID testing = ${peer.id}`);

        peerEventHandlers.error = (err) => {
          console.log(`peer error = ${err.type}`);
          console.log(`peer error = ${err.message}`);
          displayPopMessage(`PeerError: ${err.type}`);
          displayPopMessage(`PeerError: ${err.message}`);
        };

        peerEventHandlers.connection = (conn) => {
          setConnnectionHandler(conn);
          console.log('connected to peer')
          attachDataConnectionHandlers();
          // disconnectPeer as it is not needed anymore, for new match, new peer with new id will be generated
          setTimeout(() => {
            disconnectPeer();
          }, 500);

          // Initialize Match and State
          // create match object based on url
          if (props.isUltimate) {
            match = new UTTT();
          } else {
            match = new TTT();
          }
          setMatchHasStarted(true);
          startAudio.play();
          setTopMessage('You are X');
          updateMatchState(match);
          // setIAm('X');

          // setTimeout(() => {
          //   sendMessage('hi');
          // }, 100);
          // setTimeout(() => {
          //   sendMessage('communication after broker disconnection');
          // }, 10000);
        };

        // connEventHandlers.data = (data) => {
        //   console.log(data);
        // }

        attachPeerHandlers();

      } else {

        // console.log('arrived directly, gonna run use effect code');

        peerEventHandlers.open = (id) => {
          console.log('My peer ID is: ' + id);
          let peerId = fetchIdFromUrlPath();
          connectToPeerAndAttachHandlers(peerId);
        }

        peerEventHandlers.error = (err) => {
          console.log(`peer error = ${err.type}`);
          console.log(`peer error = ${err.message}`);
          displayPopMessage(`PeerError: ${err.type}`);
          displayPopMessage(`PeerError: ${err.message}`);
          if (err.type == 'peer-unavailable') {
            setNotFound(true);
          }
        };

        initializePeerAndAttachHandlers();

        // let peerId = fetchIdFromUrlPath();

        connEventHandlers.open = () => {
          console.log('connected to peer');
          setTimeout(() => {
            disconnectPeer();
          }, 500);

          // Initialize Match and State
          // create match object based on url
          if (props.isUltimate) {
            match = new UTTT();
          } else {
            match = new TTT();
          }
          setMatchHasStarted(true);
          startAudio.play();
          setTopMessage('You are O');
          updateMatchState(match);
          // setIAm('O');

          // sendMessage('hi');
          // // disconnectPeer();
          // setTimeout(() => {
          //   sendMessage('communication after broker disconnection');
          // }, 10000);
        };

      }
      // setTimeout(() => {
      //   console.log(match);
      // }, 3000);
      connEventHandlers.data = (msg) => {
        // console.log(msg);
        if (msg.type == 'MAKE_MOVE') {

          // if (!matchHasStarted || matchFinished) {
          //   console.log(`matchHasStarted = ${matchHasStarted}, match finished = ${matchFinished}`)
          //   console.log(`WARNING: player tried to make move when match was NOT ongoing`);
          //   return;
          // }
          if (!(msg.data.move)) {
            console.log(`all expected fields not present in received data`);
            return;
          }
          if (!Array.isArray(msg.data.move)) {
            console.log(`received move should be of type array`);
            return;
          }
          let XorO = (location.state && location.state.iCreatedChallenge) ? 'X' : 'O';
          if (match.getNextTurn() != getOpposite(XorO)) {
            // console.log(match.getNextTurn());
            // console.log(XorO);
            // console.log(location.state && location.state.iCreatedChallenge);
            // console.log(getOpposite(XorO));
            console.log(`not their turn to make move`);
            return;
          }
          if (!props.isUltimate) {
            if (msg.data.move.length != 2) {
              console.log(`move array of wrong length`);
              return
            }
          } else if (props.isUltimate) {
            if (msg.data.move.length != 4) {
              console.log(`move array of wrong length`);
              return
            }
          }
          // Check complete I tihnk, now try to make move
          if (match.makeMove(...(msg.data.move))) {
            // inner code will only execute if move was successfully made
            updateMatchState(match);
            moveAudio.play();
            let mResult = match.getResult();
            if (mResult != 'ongoing') {
              endMatchBasedOnResult(mResult);
            }
          }
        }
        else if (msg.type == 'RESIGN') {
          if (!matchFinished) {
            setMatchFinished(true);
            setTopMessage('You won :D, opponent resigned');
            setNextTurn(null);
            setAllAllowed(null);
            setLastMove(null);
            endAudio.play();
          }
        }
      }

    } else {

    }

    return () => {
      resetPeerHandlers();
      resetConnHandlers();
      // destroyPeer();
    };

  }, []);

  // useEffect(() => {
  //   // This is to clear location.state.iCreatedChallenge, once the page has been loaded.
  //   console.log('clearing location state');
  //   if (location.state && location.state.iCreatedChallenge) {
  //     navigate(location.pathname, { replace: true });
  //   }
  // }, []);

  if (!matchHasStarted) {
    if (location.state && location.state.iCreatedChallenge) {  // if this person did created challenge
      return (
        <div className="Game">
          <Challenge />
        </div>
      );
    } else { // if this person did not create challenge
      if (notFound) {
        return <NotFound />;
      } else {
        return <Searching />;
      }
    }
  } else {
    let XorO = (location.state && location.state.iCreatedChallenge) ? 'X' : 'O';
    return (
      <div className="Game">
        <Match isUltimate={props.isUltimate} isOngoing={!matchFinished} topMessage={topMessage} lastMove={lastMove} representations={representations} bigRepresentations={bigRepresentations} allAllowed={allAllowed} nextTurn={nextTurn} iAm={XorO} onSquareClick={squareGotClicked} backResignClick={backOrResignClicked} />
      </div>
    );
  }

  function squareGotClicked(p, q, i, j) {
    let XorO = (location.state && location.state.iCreatedChallenge) ? 'X' : 'O';
    // console.log(`clicked ${p}${q}${i}${j}`);
    // console.log(iAm);
    // console.log(location.state && location.state.iCreatedChallenge);
    if (matchFinished) {
      return;
    }
    if (!((nextTurn === 'X' && XorO === 'X') || (nextTurn === 'O' && XorO === 'O'))) {
      return;
    }
    let move;
    if (p === null && q === null) {
      move = [i, j];
    } else {
      move = [p, q, i, j];
    }
    // console.log(match);
    if (match.makeMove(...(move))) {
      // inner code will only execute if move was successfully made
      updateMatchState(match);
      let mResult = match.getResult();
      if (mResult != 'ongoing') {
        endMatchBasedOnResult(mResult);
      }
      moveAudio.play();
      sendMessage({
        type: 'MAKE_MOVE',
        data: {
          move: move,
        }
      });

    }
  }

  function backOrResignClicked() {
    if (!matchFinished) {
      sendMessage({
        type: 'RESIGN',
        data: {}
      });
      setMatchFinished(true);
      setTopMessage('Match over, you resigned');
      setNextTurn(null);
      setAllAllowed(null);
      setLastMove(null);
      endAudio.play();
    } else {
      destroyPeer();
      navigate('/', { replace: true, });
    }
  }

}

export default Game;